// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";
import React from "react";

const SkodaTheme = props => {
	useThemeStylesheet(() => import("./skoda.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default SkodaTheme;
